"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var HomeListingCard_1 = __importDefault(require("../HomeListingCard"));
var i18n_1 = __importDefault(require("../../i18n"));
var Localization_1 = require("../../constants/Localization");
var wishListSlice_1 = require("../../features/wishList/wishListSlice");
var homeListingsSlice_1 = require("../../features/homeListings/homeListingsSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var HomeListingRow = function (_a) {
    var listingKey = _a.listingKey, icon = _a.icon, searchQuery = _a.searchQuery;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var _b = react_redux_1.useSelector(homeListingsSlice_1.selectHomeListing(listingKey)), posts = _b.posts, status = _b.status;
    react_1.useEffect(function () {
        // Rows stay in the store, so coming back to the page doesn't refetch.
        if (status === 'idle') {
            dispatch(homeListingsSlice_1.getHomeListing(listingKey));
        }
    }, []);
    // Same as the search page: update the wishlist, then the heart on the card.
    var onToggleBookmark = function (post) {
        var bookmarked = !post.bookmarked;
        dispatch(bookmarked ? wishListSlice_1.addBookmark(post.id) : wishListSlice_1.removeBookmark(post.id));
        dispatch(homeListingsSlice_1.homeListingBookmarkUpdated({ id: post.id, bookmarked: bookmarked }));
    };
    var onOpen = function (post) {
        var _a, _b;
        // RouterModal returns to state.prevURL on close; without it the preview
        // falls back to the old home page ("/").
        history.push("/preview/" + ((_b = (_a = post.slug) === null || _a === void 0 ? void 0 : _a[i18n_1.default.language]) !== null && _b !== void 0 ? _b : ''), {
            prevURL: location.pathname + location.search,
        });
    };
    // An empty or failed row is hidden, so the page never shows a bare title.
    if (status !== 'succeeded' || !posts.length) {
        return null;
    }
    var textKey = "HOME.LISTINGS." + listingKey.toUpperCase();
    var searchPage = Localization_1.SellPagePrefix[i18n_1.default.language].sell;
    var allLink = "/" + searchPage + "?page=1" + (searchQuery ? "&" + searchQuery : '');
    return (react_1.default.createElement("section", { className: styles_module_scss_1.default.row },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h2", { className: styles_module_scss_1.default.title },
                    icon,
                    " ",
                    t(textKey + ".TITLE")),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.subtitle }, t(textKey + ".SUBTITLE"))),
            react_1.default.createElement(react_router_dom_1.Link, { className: styles_module_scss_1.default.all, to: allLink },
                t(textKey + ".ALL"),
                " \u2192")),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.cards }, posts.map(function (post, index) { return (react_1.default.createElement(HomeListingCard_1.default, { key: post.id, post: post, variant: listingKey, index: index, onOpen: onOpen, onToggleBookmark: onToggleBookmark })); }))));
};
exports.default = HomeListingRow;
